import { Controller } from 'react-hook-form';
import { Info } from 'luxon';
import { arrayOf } from 'utils';

import { FormControl, FormGroup, MenuItem, Select, Stack, Typography } from '@mui/material';

import FieldWrapperGizmo from '../fields/FieldWrapperGizmo';
import DayOfMonth from './DayOfMonth';


export const YearlySchedule =
({
	name = 'recurrence.yearly.yearly_date',
	label = 'Repeats Yearly on These Dates',
	help = 'On which dates each year should this repeat?',
}) =>
{
	let day_nums = arrayOf(31, (x: number) => x + 1);
	
	let month_nums = arrayOf(12, (x: number) => x + 1);
	
	let months = Info.months();
	
	
	return (
		<FieldWrapperGizmo
			label={label}
			help={help}
		>
			
			<Stack
				alignItems='center'
			>
				<Stack
					direction='row'
					sx={{
						padding: '2px 20px',
						gap: 1.5,
					}}
				>
					<FormControl
						component='fieldset'
					>
						<Controller
							name={name}
							render={({ field: { value, onChange } }) =>
								<FormGroup>
									<Select
										value={value.month}
										onChange={(e) => onChange({
											month: e.target.value,
											day: value.day,
										})}
										sx={{
											width: '120px',
											
											bgcolor: 'field.default',
											
											'&:hover': {
												bgcolor: 'field.hover',
											},
											
											'& .Mui-focused': {
												bgcolor: 'field.focus',
											},
										}}
									>
										{month_nums.map((month_num) => {
											return (
												<MenuItem
													value={month_num}
													key={month_num}
												>
													{months[month_num - 1]}
												</MenuItem>
											);
										})}
									</Select>
								</FormGroup>
							}
						/>
					</FormControl>
					<FormControl
						component='fieldset'
					>
						<Controller
							name={name}
							render={({ field: { value, onChange } }) =>
								<FormGroup>
									<Select
										value={value.day}
										onChange={(e) => onChange({
											month: value.month,
											day: e.target.value,
										})}
										sx={{
											width: '80px',
											
											bgcolor: 'field.default',
											
											'&:hover': {
												bgcolor: 'field.hover',
											},
											
											'& .Mui-focused': {
												bgcolor: 'field.focus',
											},
										}}
									>
										{day_nums.map((day_num) => {
											return (
												<MenuItem
													value={day_num}
													key={day_num}
												>
													<DayOfMonth
														day_num={day_num + 1}
													/>
												</MenuItem>
											);
										})}
									</Select>
								</FormGroup>
							}
						/>
					</FormControl>
					
					<Typography
						sx={{
							alignSelf: 'center',
						}}
					>
						of each year
					</Typography>
					
				</Stack>
			</Stack>
			
		</FieldWrapperGizmo>
	)
}


export default YearlySchedule;